import React from 'react';
import { Box, Flex, Text, TextHeadingTwo } from '@cko/primitives';
import styled from 'styled-components';
import { arrayRange } from '../../utils';
import { CopyToClipboard } from '../CopyToClipboard';
import { LoadingBlock } from '../LoadingBlock';
const LoadingBlockWithMargin = styled(LoadingBlock) `
  margin: var(--layout-stamp) var(--layout-sandgrain);
`;
const PanelHeader = styled(Flex) `
  font: var(--body-sm-medium);
  color: var(--base-text-primary);
  padding: var(--layout-soybean) var(--layout-sandgrain);
  position: relative;
`;
const PanelStyled = styled(Box).attrs({
    as: 'section',
}) ``;
function showBlocks(noOfChildren) {
    return arrayRange(1, noOfChildren).map((i) => React.createElement(LoadingBlock, { key: i }));
}
export const DetailsPanel = ({ headerText, copyText, children, loading, info, outsideGrid, singleColumn, ...rest }) => (React.createElement(PanelStyled, { mb: "var(--layout-shoe)", p: "var(--layout-sandgrain)", ...rest },
    React.createElement(PanelHeader, { justifyContent: "space-between" },
        loading ? React.createElement(LoadingBlockWithMargin, null) : React.createElement(TextHeadingTwo, null, headerText),
        !loading && copyText && (React.createElement(CopyToClipboard, { text: copyText, style: { float: 'right' }, "data-testid": `copy-${headerText}` }))),
    info !== undefined && (React.createElement(Box, { backgroundColor: "var(--action-bg-disabled)", mx: "var(--layout-spoon)", p: "var(--layout-spoon) var(--layout-saxophone)" },
        React.createElement(Text, null, info))),
    React.createElement(Box, { mt: "var(--layout-shoe)", p: "var(--layout-sandgrain)", pb: "var(--layout-shoe)" },
        React.createElement(Box, { m: "var(--layout-sandgrain)", p: "var(--layout-sandgrain)", gridTemplateColumns: singleColumn ? 'none' : '35% calc(65% - 40px)', gridTemplateRows: "auto", display: "grid", gridColumnGap: "43px", gridRowGap: "16px" }, loading ? showBlocks(children?.length) : children),
        outsideGrid)));
